export default __webpack_public_path__ + "static/media/landscape22.c27c499d.JPG";